import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import './styles/globals.css';
import { AuthProvider } from './state/AuthContext';
import { ToastProvider } from './state/ToastContext';
import { queryClient } from './state/queryClient';
import { hydratePrefetchBundle } from './state/prefetch';
import type { PrefetchBundle } from './services/api';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const bootstrapPrefetch = async () => {
  if (typeof window === 'undefined' || !window.fetch) return;
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 1500);
    const response = await fetch('/api/prefetch', { signal: controller.signal });
    clearTimeout(timeout);
    if (!response.ok) return;
    const payload = (await response.json()) as PrefetchBundle;
    hydratePrefetchBundle(queryClient, payload);
  } catch (error) {
    console.warn('Prefetch bootstrap failed', error);
  }
};

const start = async () => {
  await bootstrapPrefetch();
  root.render(
    <React.StrictMode>
      <ToastProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
          </AuthProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ToastProvider>
    </React.StrictMode>,
  );
};

void start();
